import { OriginalResponseError } from "../types"
import { ICreateIdentityPurchaseInput, ICreateIdentityPurchaseResponse, IGetidentityPricesResponse, IUpdateIdentityPurchaseInput } from "./types"

import axios, { AxiosError, AxiosInstance } from "axios"

interface IErrorResponse {
  status: number
  error: string
}

export interface IIdentitiesPresaleApi {
  getIdentityPrices(): Promise<IGetidentityPricesResponse | null>
  checkIdentityName(name: string): Promise<{ identityName: string, isAvailable: boolean } | IErrorResponse>
  createIdentityPurchase(input: ICreateIdentityPurchaseInput): Promise<ICreateIdentityPurchaseResponse | IErrorResponse>
  updateIdentityPurchase(input: IUpdateIdentityPurchaseInput): Promise<ICreateIdentityPurchaseResponse | IErrorResponse>
}

export class IdentitiesPresaleApi implements IIdentitiesPresaleApi {
  private Api: AxiosInstance

  constructor(private baseUrl: string) {
    this.baseUrl = baseUrl
    this.Api = axios.create({
      baseURL: this.baseUrl,
    })
  }

  async getIdentityPrices(): Promise<IGetidentityPricesResponse | null> {
    const { data } = await this.Api.get('/get-identity-prices')
    return data as IGetidentityPricesResponse
  }

  async checkIdentityName(name: string): Promise<{ identityName: string, isAvailable: boolean } | IErrorResponse> {
    try {
      const { data } = await this.Api.get(`/check-identity-name`, {
        params: {
          identityName: name
        }
      })
      return data as { identityName: string, isAvailable: boolean }
    } catch (error) {
      return this.handleError(error as AxiosError<OriginalResponseError>)
    }
  }

  async createIdentityPurchase(input: ICreateIdentityPurchaseInput): Promise<ICreateIdentityPurchaseResponse | IErrorResponse> {
    try { 
      const { data } = await this.Api.post('/create-presale-purchase', input)
      return data as ICreateIdentityPurchaseResponse
    } catch (error) {
      return this.handleError(error as AxiosError<OriginalResponseError>)
    }
  }

  async updateIdentityPurchase(input: IUpdateIdentityPurchaseInput): Promise<ICreateIdentityPurchaseResponse | IErrorResponse> {
    try { 
      const { data } = await this.Api.post('/update-presale-purchase', input)
      return data as ICreateIdentityPurchaseResponse
    } catch (error) {
      return this.handleError(error as AxiosError<OriginalResponseError>)
    }
  }

  private handleError(error: AxiosError<OriginalResponseError>): IErrorResponse {
    return {
      status: error.response?.status || 500,
      error: error.response?.data?.error || error.message,
    }
  }
}

